import { gql } from "@apollo/client";

export const GET_PACIENTE_SAP = gql`
query GetPacienteSAP($codigoSAP: String!, $idEvaluacion: Int!) {
    pacienteSAP(codPaciente: $codigoSAP, idEvaluacion: $idEvaluacion) {
        idPaciente
        cod_Paciente
        nombre
        tipoDoc
        numeroDoc
        domicilio
        piso
        departamento
        cP
        localidad
        provincia
        cod_Provincia
        pais
        longitud
        latitud
        observacionExtra
    }
}
`;

export const adaptPacienteSAP = (paciente) => {
  return {
    // idPaciente: paciente.idPaciente,
    codigoSAP: paciente.cod_Paciente,
    nombre: paciente.nombre,
    tipoDocumento: paciente.tipoDoc,
    numeroDocumento: paciente.numeroDoc,
    direccion: paciente.domicilio,
    provincia: paciente.provincia,
    piso: paciente.piso,
    departamento: paciente.departamento,
    codigoPostal: paciente.cP,
    localidad: paciente.localidad,
    cod_Provincia: paciente.cod_Provincia,
    pais: paciente.pais,
    longitud: paciente.longitud,
    latitud: paciente.latitud,
    observacionExtra: paciente.observacionExtra
  };
};